var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zsy-logo-div2"},[(_vm.token !== 'fceb81089b6f419aa62f5e0b82e33efe')?_c('div',{staticClass:"zsy-version"},[_vm._v("智水云微信营业厅 Version 2.0")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }